import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-extra-product-popup-picture',
  styleUrls: ['./ui-extra-product-popup-picture.component.scss'],
  template: `
    <div class="popup-wrap" [ngStyle]="{ top: pic.offsetTop + 'px' }">
      <div class="picture-wrap" (click)="onPicClick.emit()">
        <img
          [src]="pic.image | multiImage: 'original' : true : 'assets/img/content/default-cake-image.jpg'"
          alt="Cake extra product picture"
        />
        <i class="icon-close"></i>
      </div>
    </div>
  `,
})
export class UiExtraProductPopupPictureComponent {
  @Input() public pic: any;
  @Output() public onPicClick = new EventEmitter<void>();
}
